import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'itemmin0'
})
export class Itemmin0Pipe implements PipeTransform {

  transform(arr: any): any {
    if ( arr == undefined || arr == [] || arr == undefined || arr == null) {
      return arr;
    } else{
      return arr.filter((arr: any) =>{
        return arr.qty > 0
      })
    }
  }

}
